import Vue from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import router from './router/router.js'
import echarts from 'echarts'
import {localData, sessionData} from "../src/storage/storage"
import VueResource from 'vue-resource'
import http from './router/http'

Vue.use(Antd)
Vue.prototype.axios = http
Vue.prototype.$echarts = echarts 
Vue.prototype.localData = localData;
Vue.prototype.sessionData=sessionData;
Vue.use(VueResource)

new Vue({
  el: '#app',
  router,
  render: h => h(App)
});
